import { Select } from "antd";
import React from "react";

interface IChildActivitySelectProp {
    options: { value: number; label: string }[];
    [key: string]: any;
}

const ChildActivitySelect: React.FC<IChildActivitySelectProp> = ({ options, ...props }) => {
    return (
        <Select {...props} allowClear={false} getPopupContainer={(triggerNode) => triggerNode.parentElement}>
            {options?.map((data) => {
                return (
                    <Select.Option key={data.value} value={data.value}>
                        {data.label}
                    </Select.Option>
                );
            })}
        </Select>
    );
};
export default ChildActivitySelect;
